import { createRouter, createWebHistory } from 'vue-router'
import RegistrationForm from '../components/RegistrationForm.vue'

const routes = [
  {
    path: '/:companySlug?',
    name: 'Registration',
    component: RegistrationForm,
    props: true // Pass route params as props to component
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

export default router
